/**
 * Generated runtime TestId mirror for frontend/src/pages/Jobs.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const JobsTestIds = {
  btnCreateJob: "btn-create-job",
  colActions: "col-actions",
  colEnabled: "col-enabled",
  colLastRun: "col-last-run",
  colLastStatus: "col-last-status",
  colName: "col-name",
  colNextRun: "col-next-run",
  colSchedule: "col-schedule",
  colSource: "col-source",
  jobsPage: "jobs-page",
  btnCancelSchedule: (job_id: string) => `btn-cancel-schedule-${job_id}`,
  btnCancelSchedulePrefix: () => "btn-cancel-schedule-" as TestIdPrefix,
  btnEditSchedule: (job_id: string) => `btn-edit-schedule-${job_id}`,
  btnEditSchedulePrefix: () => "btn-edit-schedule-" as TestIdPrefix,
  btnSaveSchedule: (job_id: string) => `btn-save-schedule-${job_id}`,
  btnSaveSchedulePrefix: () => "btn-save-schedule-" as TestIdPrefix,
  btnTriggerJob: (job_id: string) => `btn-trigger-job-${job_id}`,
  btnTriggerJobPrefix: () => "btn-trigger-job-" as TestIdPrefix,
  inputCron: (job_id: string) => `input-cron-${job_id}`,
  inputCronPrefix: () => "input-cron-" as TestIdPrefix,
  linkJobDetail: (job_id: string) => `link-job-detail-${job_id}`,
  linkJobDetailPrefix: () => "link-job-detail-" as TestIdPrefix,
  rowJob: (job_id: string) => `row-job-${job_id}`,
  rowJobPrefix: () => "row-job-" as TestIdPrefix,
  switchEnabled: (job_id: string) => `switch-enabled-${job_id}`,
  switchEnabledPrefix: () => "switch-enabled-" as TestIdPrefix
} as const;
